module.exports = __webpack_public_path__ + "img/world-energy-trends-cover-2025.1e9ae10.jpg";